import {FC, ReactElement, SyntheticEvent} from 'react';
import Help from './Help';
import './Help.less';

export type HelpLabelProps = {
    label: string | ReactElement,
    message: string | ReactElement,
    onLabelClick?: (e: SyntheticEvent) => void,
    invertColors?: boolean,
}

const HelpLabel: FC<HelpLabelProps> = props => {
    return <div className='help__label'>
        <div className="help__label-text" onClick={props.onLabelClick}>{props.label}</div>
        <Help message={props.message}
              title={props.label}
              invertColors={props.invertColors}
        />
    </div>;
}

export default HelpLabel;